"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const urls_1 = __importDefault(require("./urls"));
const mapGetPaymentMethodResponse = (_a) => {
    var { response } = _a, otherValues = __rest(_a, ["response"]);
    const payment_methods = response === null || response === void 0 ? void 0 : response.payment_methods;
    return Object.assign({ response: {
            paymentMethods: payment_methods
                ? payment_methods === null || payment_methods === void 0 ? void 0 : payment_methods.map((_a) => {
                    var { billing_city: billingCity, billing_country: billingCountry, billing_company: billingCompany, billing_email: billingEmail, billing_first_name: billingFirstName, billing_last_name: billingLastName, billing_phone: billingPhone, billing_street: billingStreet, billing_state: billingState, billing_postal_code: billingPostalCode, card_type: cardType, card_expiration_month: cardExpirationMonth, card_expiration_year: cardExpirationYear, card_last_four: cardLastFour, name_on_card: nameOnCard, payment_type: paymentType, is_active: isActive, billing_street_2: billingStreet2 } = _a, otherValues = __rest(_a, ["billing_city", "billing_country", "billing_company", "billing_email", "billing_first_name", "billing_last_name", "billing_phone", "billing_street", "billing_state", "billing_postal_code", "card_type", "card_expiration_month", "card_expiration_year", "card_last_four", "name_on_card", "payment_type", "is_active", "billing_street_2"]);
                    return (Object.assign({ billingCity,
                        billingCountry,
                        billingCompany,
                        billingEmail,
                        billingFirstName,
                        billingLastName,
                        billingPhone,
                        billingState,
                        billingStreet,
                        billingPostalCode,
                        cardType,
                        cardExpirationMonth,
                        cardExpirationYear,
                        cardLastFour,
                        isActive,
                        nameOnCard,
                        paymentType,
                        billingStreet2 }, otherValues));
                })
                : [],
        } }, otherValues);
};
class PaymentClient {
    captureContext() {
        return this.requestProtected({
            method: 'GET',
            url: urls_1.default.captureContext(),
        });
    }
    getPaymentMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.requestProtected({
                method: 'GET',
                url: urls_1.default.paymentMethods(),
            });
            return mapGetPaymentMethodResponse(data);
        });
    }
    addPaymentMethod(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.requestProtected({
                body: data,
                method: 'POST',
                url: urls_1.default.paymentMethods(),
            });
        });
    }
}
exports.default = PaymentClient;
